/**
 * @generated SignedSource<<78630552c6d8d096bbd73970b2b0e2a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationTilTidUpdateInput = {
  secondaryScheduleTypeDimensionId?: string | null;
};
export type SelectSecondaryScheduleTypeDimensionMutation$variables = {
  input: IntegrationTilTidUpdateInput;
};
export type SelectSecondaryScheduleTypeDimensionMutation$data = {
  readonly store: {
    readonly updateIntegrationTilTid: {
      readonly id: string;
      readonly secondaryScheduleTypeOption: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null;
  };
};
export type SelectSecondaryScheduleTypeDimensionMutation = {
  response: SelectSecondaryScheduleTypeDimensionMutation$data;
  variables: SelectSecondaryScheduleTypeDimensionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "IntegrationTilTid",
        "kind": "LinkedField",
        "name": "updateIntegrationTilTid",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "IntegrationTilTidSecondaryScheduleTypeOption",
            "kind": "LinkedField",
            "name": "secondaryScheduleTypeOption",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectSecondaryScheduleTypeDimensionMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SelectSecondaryScheduleTypeDimensionMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "95fcd4bed1160852daed3e17fb377bd2",
    "id": null,
    "metadata": {},
    "name": "SelectSecondaryScheduleTypeDimensionMutation",
    "operationKind": "mutation",
    "text": "mutation SelectSecondaryScheduleTypeDimensionMutation(\n  $input: IntegrationTilTidUpdateInput!\n) {\n  store {\n    updateIntegrationTilTid(input: $input) {\n      id\n      secondaryScheduleTypeOption {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "69f94c605a998af967d926117e97c300";

export default node;
